import React, { PropsWithChildren } from 'react';

import { isMediaId } from '~/common';
import { getBrightcoveMediaId } from '~/src/common/media';

import type { Content } from './types';

import { MediaPlayerModal } from '../MediaPlayerModal';
import { MediaPlayerProvider } from '../MediaPlayerProvider';

type Props = {
  content: Content;
} & React.ComponentProps<typeof MediaPlayerModal>;

export const MediaHeroPlayerModal: React.FC<PropsWithChildren<Props>> = props => {
  const mediaId = getBrightcoveMediaId(props.content);

  if (!isMediaId(mediaId)) {
    return null;
  }

  return (
    <MediaPlayerProvider mediaId={mediaId}>
      <MediaPlayerModal {...props} />
    </MediaPlayerProvider>
  );
};
